var _rect, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetUpButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "BUTTON_Big_Green",
    xmlns: "http://www.w3.org/2000/svg",
    width: 312,
    height: 64,
    viewBox: "0 0 312 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 312,
    height: 64,
    rx: 32,
    fill: "#00ce3f"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Setup",
    transform: "translate(156 39)",
    fill: "#fff",
    fontSize: 18,
    fontFamily: "Manrope-Bold, Manrope",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -26,
    y: 0
  }, "Setup"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetUpButton);
export default __webpack_public_path__ + "static/media/setUpButton.3bc5c703b94248b01a4f77da42830b3e.svg";
export { ForwardRef as ReactComponent };